import { computed, watch } from "vue";

import { useDoorsStore } from "@/stores/new/doors.store";
import { useOverdoorStore } from "@/stores/new/overdoor.store";
import { usePartitionStore } from "@/stores/new/partition.store";

import { DimensionValue } from "../domain/entities/dimensions";
import { PricingService } from "../services/pricing.service";
import { getKompasMultiplier } from "../predicates/systems.predicates";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
export const usePartitionGlassArea = () => {
    const pricingService = new PricingService();
    const estimateStore = useNewEstimateStore();
    const partitionsStore = usePartitionStore();
    const doorsStore = useDoorsStore();
    const overdoorStore = useOverdoorStore();
    const installationSystem = computed(() => estimateStore.estimate.installedSystemCode);
    const partition = computed(() => partitionsStore.activePartitions);
    const door = computed(() => doorsStore.activeDoor);

    const partitionGlass = computed(() => partition.value?.getActiveGlass());
    const activeGlassOverdoor = computed(
        () => overdoorStore.activeGlassOverdoor,
    );
    const doorsGlass = computed(() => door.value?.getActiveGlassPartition());

    const deductDoorAndTransomGlassArea = () => {
        if (!partition.value) return;

        const kompasMultiplier = getKompasMultiplier(installationSystem.value as string);
        const partitionGlassDimensions = partition.value.dimensions.copy();
        const doorsGlassDimensions = doorsGlass.value?.dimensions.copy();
        const overdoorGlassDimensions =
            activeGlassOverdoor.value?.dimensions.copy();

        const partitionArea =
            partitionGlassDimensions?.calculateArea().getValue() || 0;

        const doorGlassArea =
            doorsGlassDimensions?.area.toInches().getValue() || 0;

        const overdoorGlass =
            overdoorGlassDimensions?.area.toInches().getValue() || 0;
        const overdoorGlassArea = (overdoorGlass / kompasMultiplier) || 0;

        const newPartitionArea =
            partitionArea - doorGlassArea - overdoorGlassArea;

        return new DimensionValue(newPartitionArea);
    };

    watch(
        () => [
            partition.value?.dimensions.area,
            doorsGlass.value?.dimensions,
            activeGlassOverdoor.value?.dimensions,
        ],
        () => {
            const newPartitionArea = deductDoorAndTransomGlassArea();
            if (!newPartitionArea) return;

            partitionGlass.value!.dimensions.area = newPartitionArea;
        },
        { deep: true, immediate: true },
    );

    watch(
        () => [
            partitionGlass.value?.price,
            partitionGlass.value?.dimensions.area,
        ],
        () => {
            if (!partitionGlass.value) return;

            const sum = pricingService.calculatePartitionGlassPrice();
            partitionGlass.value.update({ sum });
        },
        { immediate: true, deep: true },
    );
};
